import React from 'react';
import { ScrollReveal } from './ScrollReveal';
import { Check } from 'lucide-react';
import { SectionCTA } from './SectionCTA';
export function Results() {
  const results = ['Un producto digital creado y listo para vender', 'Una oferta estructurada que convierte', 'Sistema de venta activo y funcionando', 'Estrategia de contenido clara y directa', 'Primeras ventas en proceso de cierre', 'Modelo replicable para futuros productos'];
  return <section className="py-20 px-4 bg-[#0a0a1f]" data-id="element-297">
      <div className="container mx-auto max-w-5xl" data-id="element-298">
        <ScrollReveal className="text-center mb-12" data-id="element-299">
          <h2 className="text-3xl md:text-5xl font-bold mb-4" data-id="element-300">
            Al finalizar tendrás:
          </h2>
          <p className="text-gray-400" data-id="element-301">
            Resultados tangibles, no solo conocimiento.
          </p>
        </ScrollReveal>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-302">
          {results.map((result, index) => <ScrollReveal key={index} delay={index * 0.1} direction="up" data-id="element-303">
              <div className="flex items-start gap-4 p-6 rounded-2xl bg-white/5 border border-white/5 hover:border-green-500/30 transition-all duration-300" data-id="element-304">
                <div className="bg-green-500/20 p-1 rounded-full mt-1" data-id="element-305">
                  <Check className="w-5 h-5 text-green-400" data-id="element-306" />
                </div>
                <span className="text-lg text-gray-200 font-medium" data-id="element-307">
                  {result}
                </span>
              </div>
            </ScrollReveal>)}
        </div>

        <ScrollReveal delay={0.6} className="text-center mt-12" data-id="element-308">
          <p className="text-2xl font-bold text-white mb-2" data-id="element-309">
            No solo aprenderás.
          </p>
          <p className="text-2xl font-bold text-cyan-400" data-id="element-310">
            Saldrás con algo vendiendo.
          </p>
        </ScrollReveal>

        <SectionCTA headline="Obtén estos resultados por solo $16.39" buttonText="QUIERO ESTOS RESULTADOS" data-id="element-311" />
      </div>
    </section>;
}